"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hasWeex = typeof weex === 'object';
var appType = hasWeex && weex.config.env.appType;
function isDingTalkLite() {
    return appType === '2ndType/lite';
}
exports.isDingTalkLite = isDingTalkLite;
